var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledNotificaion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5856 19.0001H2.99958C2.90672 19.0001 2.8157 18.9742 2.73671 18.9254C2.65772 18.8766 2.59389 18.8067 2.55236 18.7237C2.51084 18.6406 2.49326 18.5476 2.5016 18.4552C2.50994 18.3627 2.54386 18.2744 2.59958 18.2001L2.99958 17.6671V9.00007C2.99958 7.67007 3.32358 6.41607 3.89858 5.31307L0.392578 1.80807L1.80758 0.393066L21.6066 20.1931L20.1916 21.6071L17.5856 19.0001ZM18.9996 14.7861L6.55858 2.34507C7.76332 1.54101 9.16376 1.07912 10.6105 1.00867C12.0572 0.93822 13.4959 1.26186 14.773 1.94505C16.0502 2.62824 17.1179 3.64535 17.8623 4.88785C18.6067 6.13036 18.9997 7.55165 18.9996 9.00007V14.7861ZM8.49958 20.0001H13.4996C13.4996 20.6631 13.2362 21.299 12.7673 21.7678C12.2985 22.2367 11.6626 22.5001 10.9996 22.5001C10.3365 22.5001 9.70065 22.2367 9.23181 21.7678C8.76297 21.299 8.49958 20.6631 8.49958 20.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledNotificaion);
export default __webpack_public_path__ + "static/media/disabled_notificaion.958d65484173d2e7518b5c9fa0fb3728.svg";
export { ForwardRef as ReactComponent };